const locales = ['en', 'fr', 'de', 'nl', 'pl', 'it'];

export default locales;